const boxShadow = '0 10px 30px rgba(15, 23, 42, .08)'
const primary = '#111827'
const bgPrimaryLight = `rgba(15, 23, 42, .62)`
const primaryGradient = `linear-gradient(135deg, #111827 0%, #172033 100%)`
const widthFull = '252px'
const widthResize = '76px'
const widthWithPadding = '224px'
const widthResizeWithPadding = '48px'
const heightHeader = '84px'
const heightFooter = '48px'


export {
  boxShadow, primary, bgPrimaryLight, primaryGradient, widthFull, widthResize, heightHeader, heightFooter, widthWithPadding, widthResizeWithPadding
}
